import JobOfferSummary from './JobOfferSummary';

export default JobOfferSummary;
